// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ImportListingModal.css';
import cx from 'classnames';
import bt from '../../components/commonStyle.css';
import {
  Modal
} from 'react-bootstrap';
import cross from "/public/SiteIcons/close.svg";

// Redux
import { connect } from 'react-redux';
import { closeImportListModal } from '../../actions/modalActions';

// Components
import ImportListingForm from '../ImportListingForm/ImportListingForm';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
import messages from '../../locale/messages';

class ImportListingModal extends Component {
  static propTypes = {
    closeImportListModal: PropTypes.func,
    importListingModal: PropTypes.bool,
    formatMessage: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      importListingModalStatus: false,
      isProcessing: false,
    };
    this.setIsProcessing = this.setIsProcessing.bind(this); // Bind method
    this.handleClose = this.handleClose.bind(this); // Bind custom close handler
  }

  componentDidMount() {
    const { importListModal } = this.props;
    if (importListModal === true) {
      this.setState({ importListingModalStatus: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { importListModal } = nextProps;
    if (importListModal === true) {
      this.setState({ importListingModalStatus: true });
    } else {
      this.setState({ importListingModalStatus: false });
    }
  }

  setIsProcessing(value) {
    this.setState({ isProcessing: value });
  }

  // Custom close handler to prevent closing during processing
  handleClose() {
    const { closeImportListModal } = this.props;
    const { isProcessing } = this.state;
    if (!isProcessing) {
      closeImportListModal();
    }
  }

  render() {
    const { closeImportListModal } = this.props;
    const { importListingModalStatus, isProcessing } = this.state;

    return (
      <>
        <Modal
          show={importListingModalStatus}
          animation={false}
          onHide={this.handleClose}
          dialogClassName={'importListingModal'}
          backdrop="static" // Prevents closing on outside click
          keyboard={false}  // Prevents closing with Escape key
        >
          <Modal.Header className={"bgBlack"} closeButton={!isProcessing}>
              <img src={cross}  className={s.closeIcon}/>
            <Modal.Title className={s.modalTitle}><FormattedMessage {...messages.importListModalTitle}  /></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={s.root}>
              <ImportListingForm
                setIsProcessing={this.setIsProcessing} // Pass setter
                isProcessing={isProcessing}
              />
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapState = state => ({
  importListModal: state.modalStatus.isImportModalOpen,
});

const mapDispatch = {
  closeImportListModal,
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ImportListingModal)));